/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { makeAsyncAction } from '../utils/async_utils';
import {
    ADD_RESERVATION,
    UPDATE_RESERVATION,
    FETCH_RESERVATION,
} from '../constants/actions';
import * as api from '../api';

export const createReservation = makeAsyncAction(
    ADD_RESERVATION,
    (params) => () => api.createReservation(params),
    'reservations'
);
export const updateReservation = makeAsyncAction(
    UPDATE_RESERVATION,
    (params) => () => api.updateReservation(params),
    'reservations'
);
export const fetchReservation = makeAsyncAction(
    FETCH_RESERVATION,
    (id: string) => () => api.getReservationById(id),
    'reservation'
);
